import { gql } from 'graphql-request'

export const trialStatusQuery = gql`
  query TrialStatus($corporateId: ID!) {
    trialStatus(corporateId: $corporateId) {
      trialStatus
      trialStartedAt
      trialExpiresAt
      trialConvertedAt
      daysRemaining
      onboardingProgress {
        totalSteps
        completedSteps
        progressPct
        items {
          checklistId
          stepKey
          stepLabel
          stepDescription
          category
          isCompleted
          completedAt
          sortOrder
        }
      }
    }
  }
`

export const onboardingProgressQuery = gql`
  query OnboardingProgress($corporateId: ID!) {
    onboardingProgress(corporateId: $corporateId) {
      totalSteps
      completedSteps
      progressPct
      items {
        checklistId
        stepKey
        stepLabel
        stepDescription
        category
        isCompleted
        completedAt
        sortOrder
      }
    }
  }
`

export const verifyCheckoutSessionQuery = gql`
  query VerifyCheckoutSession($sessionId: String!) {
    verifyCheckoutSession(sessionId: $sessionId) {
      corporateId
      planId
      status
    }
  }
`
